import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import * as L from "leaflet";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useMap } from "react-leaflet";
import { parseCoordinate } from "../../../utils";
export const AddPointButton = ({ onClick, }) => {
    const { t } = useTranslation();
    const map = useMap();
    const [showModal, setShowModal] = useState(false);
    const [newLat, setnewLat] = useState();
    const [newLng, setnewLng] = useState();
    useEffect(() => {
        const customControl = new L.Control({ position: "topright" });
        customControl.onAdd = function () {
            const container = L.DomUtil.create("div", "leaflet-bar leaflet-control custom-button-control");
            const button = L.DomUtil.create("a", "", container);
            button.innerHTML = "📍";
            button.href = "#";
            button.title = t("addPointButton.title");
            L.DomEvent.on(button, "click", (e) => {
                L.DomEvent.stopPropagation(e);
                L.DomEvent.preventDefault(e);
                setShowModal(true);
            });
            return container;
        };
        customControl.addTo(map);
        return () => {
            customControl.remove();
        };
    }, [map]);
    const closeModal = () => {
        setShowModal(false);
        setnewLat(undefined);
        setnewLng(undefined);
    };
    const addPoint = (point) => {
        onClick(point);
        map.setView(point);
        closeModal();
    };
    return (_jsx(_Fragment, { children: showModal ? (_jsx("div", { className: "modal-wrapper", children: _jsxs("dialog", { open: true, onCancel: closeModal, children: [_jsx("h4", { children: t("addPointButton.modal.title") }), _jsxs("div", { className: "text-center", children: [_jsx("div", { className: "input-wrapper", children: _jsx("input", { value: newLat, onChange: (e) => setnewLat(e.target.value), name: "lat", placeholder: t("addPointButton.modal.lat") }) }), _jsx("div", { className: "input-wrapper", children: _jsx("input", { value: newLng, onChange: (e) => setnewLng(e.target.value), name: "lng", placeholder: t("addPointButton.modal.lng") }) }), _jsx("button", { className: "btn btn-primary", onClick: () => addPoint({
                                    lat: parseCoordinate(newLat),
                                    lng: parseCoordinate(newLng),
                                }), children: t("addPointButton.modal.addButton") }), _jsx("button", { className: "btn btn-secondary", onClick: closeModal, children: t("addPointButton.modal.closeButton") })] })] }) })) : null }));
};
